import React from 'react';
import { Text, View } from 'react-native-web';

//= ========================================================================

const BottomPanelButton = ({
  text, globJSON,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyle = {
    container: {
      position: 'absolute',
      backgroundColor: 'white',
      width: '100%',
      padding: 7,
      textAlign: 'center',
      bottom: 0,
      boxShadow: '0 -1px 9px 0 rgba(0, 0, 0, 0.07)',
    },
    linkText: {
      fontSize: 9.3,
      fontWeight: 600,
      color: colors.primary_cta_color,
    },
  };
  return (
    <View style={myStyle.container}>
      <Text style={myStyle.linkText}>
        {text}
      </Text>
    </View>
  );
};
export default BottomPanelButton;
